export default __webpack_public_path__ + "static/media/e&logo.1956bf5e.svg";